import { useState, useEffect, forwardRef, useMemo } from "react";
import {
  Button,
  Col,
  Container,
  Form,
  InputGroup,
  Modal,
  Row,
  Table,
} from "react-bootstrap";
import axios from "axios";
import BASE_URL from "../../../assets/global/url";
import {
  useNavigate,
  useParams,
  Link,
  useLocation,
  useSearchParams,
} from "react-router-dom";
import swal from "sweetalert";
import { validateCheckNumbers } from "../../../utils/checkNumberValidator";
import CheckNumberError from "../../../components/inputs/CheckNumberError";
// import BulkPayable from "./BulkPayable";
import { customStyles } from "../../../assets/table-style";
import DataTable from "react-data-table-component";
import useDecodeToken from "../../../hooks/customHook/useDecodeToken";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import { useServerPagination } from "../../../hooks/customHook/paginationHook/useServerPagination";
import { PaginationControls } from "../../../hooks/customHook/paginationHook/usePagination";
import Select from "react-select";
import { selectCustomStyles } from "../../../assets/global/selectCustomStyles";
import useDarkMode from "../../../components/Themes/Usedarkmode";
// import { useDateValidation } from "../../../hooks/customHook/useDateValidation";
import { usePostedCutoffValidation } from "../../../hooks/customHook/usePostedCutoffValidation";
import CustomDatePicker from "../../../components/CustomDatePicker";
import {
  parseNumber,
  truncateToTwoDecimals,
  currencySymbol,
  formatToTwoDecimal,
  // parseNumber,
  // sanitizeAmount,
  // formatNumberWithComma,
} from "../../../utils/numberFormatter";
import NumberInDecimals from "../../../components/inputs/NumberFormatted";
import TypedDateInput from "../../../components/inputs/TypedDateInput";
import { BulkPayableHistoryModal } from "./BulkPayableHistoryModal";
import { formatDateForColumn } from "../../../utils/dateFormatter";
import { warnIfNoCutoff } from "../../../utils/cutoffDateValidation";

const NEW_view_bulk_payable = ({
  authrztn,
  setId,
  setIdToAdd,
  setEdit, // To determine if user is still editing then suddenly navigates to other page
  setRoute,
}) => {
  const { id, module } = useParams();
  const navigate = useNavigate();
  const { themeSelectStyles } = useDarkMode();
  const location = useLocation();

  const [payableBulk, setPayableBulk] = useState([]);
  const [transactionNumber, setTransactionNumber] = useState("");
  const [vendor, setVendor] = useState(null);
  const [processDate, setProcessDate] = useState("");
  const [status, setStatus] = useState("");
  const [currency, setCurrency] = useState("");
  const [vendorMap, setVendorMap] = useState([]);
  const [availablePayables, setAvailablePayables] = useState([]);
  const [selectedVendorId, setSelectedVendorId] = useState(null);
  const [allCurrency, setAllCurrency] = useState([]);
  const [payableList, setPayableList] = useState([]);
  const [isCutoffPosted, setIsCutoffPosted] = useState(false);
  const [isCutoffExists, setIsCutoffExists] = useState(true);
  const [isEditing, setIsEditing] = useState(false);

  const userLoggedID = useDecodeToken();
  // const { dateValidation } = useDateValidation();
  const { postedCutoffValidation } = usePostedCutoffValidation();

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [selectedRow, setSelectedRow] = useState([]);
  const [removeIdsPaymentList, setRemoveIdsPaymentList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterColumn, setFilterColumn] = useState("all");
  const [storePreviousAvailablePayable, setStorePreviousAvailablePayable] =
    useState([]);
  // const [withIsAddedPayable, setWithIsAddedPayable] = useState([]);
  const [selectedTransactionIds, setSelectedTransactionIds] = useState([]);
  const [searchParams] = useSearchParams();
  const [selectedRowTransactions, setSelectedRowTransactions] = useState([]);
  const [transactionToGetBack, setTransactionToGetBack] = useState([]);
  const [currencyRate, setCurrencyRate] = useState(1);
  const [floatPayment, setFloatPayment] = useState([]);
  // console.log(floatPayment);
  const [overAllDiscount, setOverallDiscount] = useState({
    type: "amount",
    value: 0,
    convertedAmount: 0,
  });
  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const [hasSelectedNewProcessDate, setHasSelectedNewProcessDate] =
    useState(false);

  //*************PAYMENT METHOD***************** */
  const [selectedPayment, setSelectedPayment] = useState("Bank");
  const [onlinePaymentCheckbox, setOnlinePaymentCheckbox] = useState(false);
  const [issueCheckDate, setIssueCheckDate] = useState("");
  const [validated, setValidated] = useState(false);

  const [subject1, setSubject1] = useState("");
  const [subject2, setSubject2] = useState("");
  const [subject3, setSubject3] = useState("");

  const [subject2DataList, setSubject2DataList] = useState([]);
  const [subject3DataList, setSubject3DataList] = useState([]);
  const [isSubject2Disabled, setIsSubject2Disabled] = useState(true);
  const [isSubject3Disabled, setIsSubject3Disabled] = useState(true);

  const [totalAmountSum, setTotalAmountSum] = useState(0);
  const [bankAmount, setBankAmount] = useState(0);
  const [checkNumber, setCheckNumber] = useState("");
  const [refNumber, setRefNumber] = useState("");
  const [accountName, setAccountName] = useState("");
  const [amount, setAmount] = useState("");
  const [onlineWalletRemarks, setOnlineWalletRemarks] = useState("");
  const [editableRow, setEditableRow] = useState(null);
  const [editedData, setEditedData] = useState({});

  const [removeIds, setRemoveIds] = useState([]);

  const [accessType, setAccessType] = useState("");
  // Access type (Management/Employee) of the logged in user, used to decide
  // whether the account balance is shown or hidden on this screen.
  const fetchAccessType = () => {
    axios
      .get(`${BASE_URL}/userRole/getUserAccessType/${userLoggedID}`)
      .then((res) => {
        setAccessType(res.data.accessType);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (userLoggedID) {
      fetchAccessType();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userLoggedID]);

  const handleDeletePayment = (index, data) => {
    setFloatPayment((prevPayments) => {
      const filteredPayments = prevPayments.filter((_, i) => i !== index);

      const updatedPayments = filteredPayments.map((payment, newIndex) => {
        const baseTn = payment.transactionNumber
          ? payment.transactionNumber.split("_p")[0]
          : transactionNumber;

        return {
          ...payment,
          transactionNumber: `${baseTn}_p${newIndex + 1}`,
        };
      });

      return updatedPayments;
    });

    if (data.id) {
      setRemoveIdsPaymentList((prev) => [...prev, data.id]);
    }
  };

  const submitModal = () => {
    const mergedData = [
      ...new Set([...selectedRow, ...selectedRowTransactions]),
    ];

    fetchPayableList(
      payableBulk.vendor_id,
      module,
      searchTerm,
      filterColumn,
      payableList,
      payableBulk.currency_id,
      [],
      mergedData,
    );

    setSelectedRowTransactions(mergedData);

    pagination.setCurrentPage(1);
    // setSelectedRow([]);
    setFilterColumn("all");
    setSearchTerm("");
    handleClose();
  };

  const handleIndividualCheckBoxChange = (id) => {
    if (selectedRow.includes(id)) {
      setSelectedRow((prev) => {
        return prev.filter((item) => id !== item);
      });
    } else {
      setSelectedRow((prev) => {
        return [...prev, id];
      });
    }
  };

  const handleAllCheckboxChange = (e) => {
    const isChecked = e.target.checked;
    if (isChecked === true) {
      setSelectedRow(availablePayables.map((item) => item.id));
    } else {
      setSelectedRow([]);
    }
  };

  const modalColumn = [
    {
      name: (
        <input type="checkbox" onChange={(e) => handleAllCheckboxChange(e)} />
      ),
      cell: (row) => (
        <input
          type="checkbox"
          checked={selectedRow.includes(row.id)}
          onChange={() => handleIndividualCheckBoxChange(row.id)}
        />
      ),
    },
    {
      name: "Transaction ID",
      selector: (row) => (
        <>
          <span className="d-none">{row.transaction_id || "---"}</span>
          <span>{row.client_transaction_id || "---"}</span>
        </>
      ),
    },
    {
      name: "Remarks",
      selector: (row) => row.description || "---",
    },
    {
      name: "Purchase Date",
      selector: (row) => formatDateForColumn(row.purchaseDate),
    },
    {
      name: "Due Date",
      selector: (row) => formatDateForColumn(row.due_date),
    },
    {
      name: "Amount",
      selector: (row) =>
        row.totalPrice ? formatToTwoDecimal(row.totalPrice) : "---",
    },
    // {
    //   name: "Discount",
    //   selector: (row) => `${row.discount_value}`,
    // },
  ];

  const currencyName = allCurrency.find(
    (item) => item.id === currency,
  )?.currency_name;

  const addNewItem = () => {
    if (availablePayables.every((item) => item.isAdded === false)) {
      fetchPayableList(
        selectedVendorId,
        module,
        searchTerm,
        filterColumn,
        payableList,
        payableBulk.currency_id,
        [],
        selectedRowTransactions,
      );
    }

    handleShow();
  };

  const deleteItem = async (item, index) => {
    setPayableList((prev) => {
      return prev.filter((_, i) => index !== i);
    });

    setSelectedRow((prev) => {
      return prev.filter((itemRow) => itemRow !== item.payable.id);
    });

    setSelectedRowTransactions((prev) => {
      return prev.filter((itemRow) => itemRow !== item.payable.id);
    });

    setRemoveIds((prev) => {
      return [...prev, item.payable.id];
    });

    if (item.payable.isAdded === true) {
      // await axios.put(`${BASE_URL}/payable/deleteOrderListTransaction`, {
      //   id,
      //   idToRemove: item.payable.id,
      // });

      setTransactionToGetBack((prev) => [...prev, item.payable.id]);
      setIdToAdd((prev) => [...prev, item.payable.id]);
      setId(id);
      setRoute("payable");
    }
  };

  const fetchCurrency = async () => {
    try {
      let res = await axios.get(`${BASE_URL}/currency/fetchCurrency`);
      setAllCurrency(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  const dateToday = () => {
    const today = new Date();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    const year = today.getFullYear();

    return `${year}-${month}-${day}`;
  };

  const pagination = useServerPagination(
    `${BASE_URL}/payable/getInfobyVendor`,
    10,
  );

  const fetchPayableList = (
    vendorId,
    module,
    searchTerm,
    filterColumn,
    payableList,
    currency,
    selectedTransactionIds = [],
    newSelectedTransactions,
  ) => {
    pagination.updateParams({
      id: vendorId,
      module: module,
      searchText: searchTerm,
      filterColumn,
      payableList: payableList.map((item) => item.id),
      currency,
      selectedTransactions: newSelectedTransactions,
    });
    setSelectedTransactionIds(selectedTransactionIds);
    setSelectedVendorId(vendorId);
  };

  const fetchExistingData = () => {
    axios
      .get(`${BASE_URL}/payable/getPayableBulk/${id}`)
      .then((res) => {
        const { data, dataTransaction, dataPayment, isPosted, cutoffExists } =
          res.data;
        setPayableBulk(data);
        setProcessDate(data?.payable_date);
        setTransactionNumber(data?.transaction_number);
        setCurrency(data?.currency_id);
        setCurrencyRate(data?.rate);
        setStatus(data?.status);
        setOverallDiscount({
          type: data?.ovad_t,
          value: data?.ovad_value,
          convertedAmount: data?.ovad_converted,
        });

        const modifiedTransaction = dataTransaction.map((item) => {
          return {
            ...item,
            totalAmount: item.payable.totalPrice,
            closedDiscountType: item.closed_discount_type || "percent",
            closedDiscountValue: item.closed_discount_value || "",
            closedDiscountOperator: item.closed_discount_operator || "+",
          };
        });

        setPayableList(modifiedTransaction);
        console.log(dataTransaction, "datatransaction");

        const vendorId = data.vendor_id;

        const selectedTransactionIds = dataTransaction.map(
          (item) => item.transactionId,
        );

        fetchPayableList(
          vendorId,
          module,
          searchTerm,
          filterColumn,
          payableList,
          data.currency_id,
          selectedTransactionIds,
          dataTransaction.map((item) => item.payable.id),
        );

        setSelectedRowTransactions(
          dataTransaction.map((item) => item.payable.id),
        );

        setFloatPayment(() => {
          return dataPayment.map((item) => {
            return {
              id: item.id,
              transactionNumber: item.transaction_number || "---",
              paymentMethod: item.payment_type,
              subject1:
                item.account_list_sub3.account_list_base_sub.module_type.toString(),
              subject2:
                item.account_list_sub3.account_list_base_sub_id.toString(),
              subject3: item.accountList_id.toString(),
              accountName: item.account_list_sub3.account_name,
              amount: item.amount,
              issuedDate: item.date_issued,
              processDate: item.process_date || "",
              checkNumber: item.check_number || "",
              refNumber: item.ref_number || "",
              remarks: "",
              status: item.payment_status || "",
              isDeleted: item.isDeleted,
            };
          });
        });

        setIsCutoffPosted(isPosted);
        setIsCutoffExists(cutoffExists);
      })
      .catch((error) => {
        console.error("Error fetching PayableBulk:", error);
      });
  };

  useEffect(() => {
    fetchPayableList(
      selectedVendorId,
      module,
      searchTerm,
      filterColumn,
      payableList,
      payableBulk.currency_id,
      [],
      selectedRowTransactions,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTerm]);

  useEffect(() => {
    if (
      searchTerm === "" &&
      availablePayables?.some((item) => item.isAdded === true)
    ) {
      setAvailablePayables(storePreviousAvailablePayable);
    } else {
      setAvailablePayables(
        storePreviousAvailablePayable.length > 0
          ? [
              ...pagination.data.isFetch?.filter(
                (payable) =>
                  !selectedTransactionIds.includes(payable.transaction_id),
              ),
              ...storePreviousAvailablePayable
                .filter((item) => {
                  const includesSearchTerm = (str, searchTerm) => {
                    return String(str)
                      .toLowerCase()
                      .includes(searchTerm.toLowerCase());
                  };
                  // Check if the item is added
                  if (item.isAdded === true) {
                    // If filterColumn is "all", check against multiple fields
                    if (filterColumn === "all") {
                      return [
                        item.transaction_id,
                        item.description,
                        item.purchaseDate,
                        item.due_date,
                        item.totalPrice,
                        item.discount_value,
                      ].some((value) => includesSearchTerm(value, searchTerm));
                    } else {
                      // If filterColumn is not "all", check if the specific column includes the searchTerm
                      return includesSearchTerm(item[filterColumn], searchTerm);
                    }
                  }
                  return false; // Return false if item.isAdded is not true
                })
                .filter(
                  (item) =>
                    !payableList.map((item) => item.id).includes(item.id), // Avoid duplicate items
                ),
            ]
          : pagination.data.isFetch?.filter(
              (payable) =>
                !selectedTransactionIds.includes(payable.transaction_id),
            ),
      );
    }

    if (pagination?.data?.items) {
      // Skip if all selectedRows already exist in Order List Table
      const existingIds = payableList.map((item) => item.payable?.id);
      const isFullySynced =
        selectedRowTransactions.every((id) => existingIds.includes(id)) &&
        payableList.length === selectedRowTransactions.length;

      if (isFullySynced) return;

      const newItems = pagination.data.items.filter(
        (item) =>
          selectedRowTransactions.includes(item.id) &&
          !existingIds.includes(item.id),
      );

      if (newItems?.length > 0) {
        setPayableList((prev) => {
          const newPayables = newItems.map((item) => {
            // Find the selected payable for the current item
            const selectedPayable = pagination.data.items.find(
              (payable) => payable.transaction_id === item.transaction_id,
            );
            console.log(selectedPayable, "selected payable");

            // Extract product price from payable_products
            const productPrice =
              selectedPayable?.payable_products?.[0]?.product_tag_vendor
                ?.product_price || "";

            return {
              ...item,
              id: item.id || "",
              transactionId: item.transaction_id || "",
              invoiceDate: item.createdAt || "",
              purchaseDate: item.purchaseDate || "",
              description: item.description || "",
              dueDate: item.due_date || "",
              amount: productPrice || "",
              discount: item.discount_value || "",
              totalAmount: item.totalPrice,
              payable: selectedPayable || null,
              closedDiscountType: "percent",
              closedDiscountValue: "",
              closedDiscountOperator: "+",
              newItemList: true,
            };
          });
          return [...prev, ...newPayables];
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.data.isFetch, pagination.data.items]);

  useEffect(() => {
    if (pagination.currentPage === 1 && availablePayables?.length < 10) {
      pagination.setTotalPages(
        Math.ceil(availablePayables?.length / pagination.itemsPerPage),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [availablePayables]);

  useEffect(() => {
    setSearchTerm("");
  }, [filterColumn]);

  useEffect(() => {
    fetchExistingData();
    fetchCurrency();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    axios
      .get(BASE_URL + "/vendors/fetchVendors")
      .then((response) => {
        const mappedVendors = response.data.map((data) => ({
          value: data.id,
          label: data.company_name,
        }));
        setVendorMap(mappedVendors);
      })
      .catch((error) => {
        console.error("Error fetching supplier:", error);
      });
  }, []);

  const activePaymentList = floatPayment
    .map((payment, i) =>
      editableRow === i ? { ...payment, ...editedData } : payment,
    )
    .filter(
      (payment) => payment.status !== "Rejected" && payment.isDeleted !== true,
    );

  const totalCashPaid = activePaymentList.reduce(
    (acc, data) =>
      data.paymentMethod === "Cash"
        ? acc + parseFloat(String(data.amount).replace(/,/g, "") || 0)
        : acc,
    0,
  );

  const totalBankPaid = activePaymentList.reduce(
    (acc, data) =>
      !data.checkNumber && !data.refNumber && data.paymentMethod === "Bank"
        ? acc + parseFloat(String(data.amount).replace(/,/g, "") || 0)
        : acc,
    0,
  );

  const totalCheckPaid = activePaymentList.reduce(
    (acc, data) =>
      data.checkNumber
        ? acc + parseFloat(String(data.amount).replace(/,/g, "") || 0)
        : acc,
    0,
  );

  const totalOnlinePaid = activePaymentList.reduce(
    (acc, data) =>
      data.refNumber && data.paymentMethod === "Bank"
        ? acc + parseFloat(String(data.amount).replace(/,/g, "") || 0)
        : acc,
    0,
  );

  const totalPayment = activePaymentList.reduce(
    (acc, data) => acc + parseFloat(String(data.amount).replace(/,/g, "") || 0),
    0,
  );

  const toPayAmount =
    parseFloat(totalAmountSum) - parseNumber(overAllDiscount.convertedAmount);

  const balance_now = toPayAmount - totalPayment;

  // LIFTED THIS DEFINITION UP HERE SO CUSTOM INPUT HAS ACCESS TO IT
  const isPaymentInputDisabled =
    status === "Rejected" ||
    balance_now <= 0 ||
    (status === "For-Approval" && !isEditing);

  useEffect(() => {
    let grossAmount = 0;
    let totalDiscount = 0;

    payableList.forEach((item) => {
      const amount = parseFloat(item.totalAmount) || 0;
      grossAmount += amount;

      let itemDiscount = 0;
      const discVal = parseFloat(item.closedDiscountValue) || 0;

      if (item.closedDiscountType === "percent") {
        itemDiscount = (discVal / 100) * amount;
      } else {
        itemDiscount = discVal;
      }

      if (item.closedDiscountOperator === "-") {
        totalDiscount -= itemDiscount;
      } else {
        totalDiscount += itemDiscount;
      }
    });

    setTotalAmountSum(grossAmount);
    setOverallDiscount({
      type: "amount",
      value: totalDiscount,
      convertedAmount: totalDiscount,
    });
  }, [payableList]);

  // const generateFilteredOptions = (index) => {
  //   // List all transaction IDs except those already selected
  //   const selectedTransactionIds = payableList
  //     .filter((_, i) => i !== index)
  //     .map((item) => item.transactionId);

  //   return availablePayables.filter(
  //     (payable) => !selectedTransactionIds.includes(payable.transaction_id),
  //   );
  // };

  // useEffect(() => {
  //   generateTransactionNumber();
  // }, []);

  // const generateTransactionNumber = () => {
  //   const today = new Date();
  //   const year = today.getFullYear();
  //   const month = String(today.getMonth() + 1).padStart(2, "0");
  //   const day = String(today.getDate()).padStart(2, "0");
  //   const dateToday = `${year}${month}${day}`;

  //   let lastTransaction = localStorage.getItem(`transaction-${dateToday}`);
  //   // let newTransactionNumber;

  //   // if (lastTransaction) {
  //   //   const lastNumber = parseInt(lastTransaction.slice(-4));
  //   //   const incrementedNumber = String(lastNumber + 1).padStart(4, "0");
  //   //   newTransactionNumber = `${dateToday}${incrementedNumber}`;
  //   // } else {
  //   //   newTransactionNumber = `${dateToday}0001`;
  //   // }

  //   // localStorage.setItem(`transaction-${dateToday}`, newTransactionNumber);

  //   // setTransactionNumber("AP" + newTransactionNumber);
  // };

  // console.log(removeIds, "removedIDS");

  // useEffect(() => {
  //   if (amountInputted) {
  //     handleAmountValue(amountInputted);
  //   }
  // }, [date]);

  const handlePaymentMethod = (e) => {
    if (checkProcessDateForPayment()) return;
    if (checkEditPayment()) return;

    const paymentMethod = e.target.value;
    setSelectedPayment(paymentMethod);
    setSubject1("");
    setSubject2("");
    setSubject3("");
    setRefNumber("");
    setCheckNumber("");
    setAmount("");
    setBankAmount(0);
    setAccountName("");
    setIsSubject2Disabled(true);
    setIsSubject3Disabled(true);
  };

  const handleOnlineCheck = (e) => {
    setOnlinePaymentCheckbox(e.target.checked);
  };

  const handleSubject1Change = (event) => {
    if (checkProcessDateForPayment()) return;
    if (checkEditPayment()) return;

    const selectedSubject1 = event.target.value;
    let account_selected = "";

    if (selectedSubject1 === "Account-List") {
      account_selected = "Account-List";
    } else if (selectedSubject1 === "Asset Account") {
      account_selected = "Asset Account";
    } else if (selectedSubject1 === "Liabilities Account") {
      account_selected = "Liabilities Account";
    } else if (selectedSubject1 === "Owner's Equity Account") {
      account_selected = "Owner's Equity Account";
    }

    const clearSubjects = () => {
      setSubject1("");
      setSubject2("");
      setSubject3("");
      setAmount("");
      setIsSubject2Disabled(true);
      setIsSubject3Disabled(true);
      setBankAmount(0);
      setAccountName("");
    };

    try {
      axios
        .get(`${BASE_URL}/payable/getSubject1LocalPayable`, {
          params: {
            account_selected: account_selected,
            selectedPayment,
            selected_currency_id: currency,
          },
        })
        .then((res) => {
          setSubject1(selectedSubject1);
          setSubject2("");
          setSubject3("");
          setAmount("");
          setBankAmount(0);
          setAccountName("");
          setIsSubject2Disabled(false); // Enable Subject 2 after Subject 1 selection
          setIsSubject3Disabled(true); // Reset and disable Subject 3

          setSubject2DataList(res.data); //retrieve subject 2 data
        })
        .catch((error) => {
          if (error.response && error.response.status === 404) {
            swal({
              icon: "warning",
              title: "Warning",
              text: error.response.data.message,
            }).then(() => clearSubjects());
            return;
          }
          // Handle other errors
          throw error;
        });
    } catch (error) {
      console.log(error);
      swal({
        title: "Something went wrong",
        text: "Please contact your support immediately",
        icon: "error",
      });
    }
  };

  const handleSubject2Change = (selectedOption) => {
    if (checkProcessDateForPayment()) return;
    if (checkEditPayment()) return;

    const selectedSubject2 = selectedOption;

    try {
      axios
        .get(`${BASE_URL}/payable/getSubject3LocalPayable`, {
          params: {
            subjectId: selectedSubject2?.value,
            totalAmountSum,
          },
        })
        .then((res) => {
          const subject3Currency = res.data.filter((item) => {
            return item.currency_id === payableBulk.currency_id;
          });
          setSubject3DataList(subject3Currency);
          setSubject2(selectedSubject2);
          setSubject3("");
          setAmount("");
          setBankAmount(0);
          setAccountName("");
          setIsSubject3Disabled(false); // Enable Subject 3 after Subject 2 selection
        });
    } catch (error) {
      console.log(error);
      swal({
        title: "Something went wrong",
        text: "Please contact your support immediately",
        icon: "error",
      });
    }
  };

  const handleAccountChange = (selectedOption) => {
    if (checkProcessDateForPayment()) return;
    if (checkEditPayment()) return;

    const selectedAccountId = selectedOption?.value;
    setSubject3(selectedOption);
    const selectedAccount = subject3DataList.find(
      (account) => String(account.id) === String(selectedAccountId),
    );

    if (selectedAccount) {
      setBankAmount(selectedAccount.amount);
      setAccountName(selectedAccount.account_name);
      // Auto-fill with the Payable Balance (gross - overall discount - payments made)
      setAmount(Math.max(balance_now, 0).toFixed(2).toString());
    }
  };

  const handleAmountValue = (val) => {
    if (checkProcessDateForPayment()) return;
    if (checkEditPayment()) return;

    if (val === "" || val === ".") {
      setAmount(val);
      return;
    }

    const numericValue = parseFloat(val);
    const formatBankAmount = parseNumber(bankAmount);
    const isLiability = subject1 === "Liabilities Account";

    let maxAllowedAmount = balance_now;
    let triggeredBy = "payable_balance";

    if (!isLiability && formatBankAmount < balance_now) {
      maxAllowedAmount = formatBankAmount;
      triggeredBy = "account_balance";
    }

    if (numericValue > maxAllowedAmount) {
      if (triggeredBy === "account_balance") {
        swal({
          icon: "warning",
          title: "Amount Adjusted",
          text:
            accessType === "Management"
              ? `Please input not greater than the account balance. The amount adjusted to match your remaining balance (${truncateToTwoDecimals(maxAllowedAmount)}).`
              : `Please input not greater than the account balance. The amount has been adjusted to match the available balance.`,
          buttons: false,
          timer: 2000,
        });
      } else {
        swal({
          icon: "warning",
          title: "Amount Adjusted",
          text:
            accessType === "Management"
              ? `Please input not greater than the account balance. The amount adjusted to match your remaining balance (${truncateToTwoDecimals(maxAllowedAmount)}).`
              : `Please input not greater than the account balance. The amount has been adjusted to match the available balance.`,
          buttons: false,
          timer: 2000,
        });
      }
      setAmount(maxAllowedAmount.toFixed(2).toString());
      return;
    }

    setAmount(val);
  };

  const handleAddPayment = async (e) => {
    e.preventDefault();

    if (checkProcessDateForPayment()) return;
    if (checkEditPayment()) return;

    const form = e.currentTarget;
    const formatAmount = parseFloat(amount);

    if (form.checkValidity() === false) {
      swal({
        icon: "error",
        title: "Fields are required",
        text: "Please fill the red text fields",
        buttons: false,
        timer: 2000,
      });
    } else {
      if (formatAmount <= 0) {
        swal({
          icon: "warning",
          title: "Warning: Invalid Amount",
          text: "The Amount must be greater than zero to proceed",
        });
        return;
      }

      // Validate key fields
      if (!selectedPayment || !formatAmount || !issueCheckDate) {
        swal({
          icon: "error",
          title: "Missing Fields",
          text: "Please complete all required fields.",
          buttons: false,
          timer: 2000,
        });
        return;
      }

      if (
        selectedPayment === "Bank" &&
        checkNumber &&
        !(await validateCheckNumbers(checkNumber, {
          pending: floatPayment
            .filter((payment) => !payment.isDeleted)
            .map((payment) => payment.checkNumber),
        }))
      )
        return;

      swal({
        title: "Add this new Payment?",
        text: "You are about to add a new payment. Do you want to proceed?",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then(async (confirmed) => {
        const isForApproval = status === "For-Approval";

        const newPayment = {
          paymentMethod: selectedPayment,
          subject1: subject1,
          subject2: subject2?.value,
          subject3: subject3?.value,
          accountName: accountName,
          amount: formatAmount,
          issuedDate: issueCheckDate,
          processDate: processDate,
          checkNumber: checkNumber,
          refNumber: refNumber,
          remarks: onlineWalletRemarks,
          transactionNumber: `${transactionNumber}_p${floatPayment.length + 1}`,
        };

        if (confirmed && isForApproval) {
          setFloatPayment((prevPayment) => {
            if (!prevPayment || prevPayment.length === 0) {
              return [...prevPayment, newPayment];
            }

            const existingPaymentIndex = prevPayment.findIndex((item) => {
              const {
                amount: itemAmount,
                transactionNumber: itemTn,
                ...itemRest
              } = item;
              const {
                amount: newPaymentAmount,
                transactionNumber: newTn,
                ...newPaymentRest
              } = newPayment;
              return (
                JSON.stringify(itemRest) === JSON.stringify(newPaymentRest)
              );
            });

            if (existingPaymentIndex !== -1) {
              return prevPayment.map((item, index) => {
                if (index === existingPaymentIndex) {
                  return {
                    ...item,
                    amount: item.amount + newPayment.amount,
                  };
                }
                return item;
              });
            } else {
              return [...prevPayment, newPayment];
            }
          });

          swal({
            icon: "success",
            title: "Payment Added",
            text: "The new payment has been added successfully",
            buttons: false,
            timer: 2000,
          }).then(() => {
            clearPaymentFields();
          });
        }

        // Handles payment for approved payable bulk
        if (confirmed && !isForApproval) {
          try {
            const res = await axios.post(`${BASE_URL}/payable/payment`, {
              payableBulkId: id,
              newPayment,
              transactionNumber: payableBulk?.transaction_number,
              userLoggedID,
              module,
              currencyRate,
            });

            if (res.status === 204) {
              swal({
                icon: "success",
                title: "Payment Added",
                text: "The new payment has been added successfully",
                buttons: false,
                timer: 2000,
              }).then(() => {
                clearPaymentFields();
                setHasSelectedNewProcessDate(false);
                setProcessDate("");

                fetchExistingData();
              });
            }
          } catch (error) {
            console.error(error);
          }
        }
      });
    }
    setValidated(true);
  };

  const clearPaymentFields = () => {
    setValidated(false);
    setOnlinePaymentCheckbox(false);
    setRefNumber("");
    setOnlineWalletRemarks("");
    setAccountName("");
    setAmount("");
    setCheckNumber("");
    setRefNumber("");
    setIssueCheckDate("");
    setSubject1("");
    setSubject2("");
    setSubject3("");
    setIsSubject2Disabled(true);
    setIsSubject3Disabled(true);
  };

  const handleSavePayment = async () => {
    if (!processDate) {
      swal({
        icon: "error",
        title: "Missing Transaction Date",
        text: "A transaction date is required to proceed. Please select a date before submitting.",
      });
      return;
    }

    const confirmed = await swal({
      title: "Create this new payable?",
      text: "",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    });

    const currentLocation = location.pathname.includes(
      "view-bulk-payable/local",
    )
      ? "Local"
      : "Overseas";

    if (confirmed) {
      try {
        const res = await axios.post(`${BASE_URL}/payable/updatePayment`, {
          id,
          payableList,
          transactionNumber,
          selectedVendorId,
          floatPayment,
          balance: totalAmountSum,
          discount_type: overAllDiscount.type,
          discount_value: overAllDiscount.value,
          discount_converted: parseNumber(overAllDiscount.convertedAmount),
          totalAmountSum,
          processDate,
          subject3,
          addedIds: payableList
            .filter((item) => item.payable.isAdded !== true)
            .map((item) => item.id),
          removeIds: [...new Set(removeIds)],
          removeIdsPaymentList,
          userLoggedID,
          currentLocation,
          currencyRate,
        });

        if (res.status === 200) {
          swal({
            title: "Success",
            text: "Payable Payment has been added successfully",
            icon: "success",
            buttons: false,
            timer: 2000,
            dangerMode: true,
          }).then(() => {
            navigate(`/purchases/view-bulk-payable/${module}/${id}`);
            setValidated(false);
            setSelectedPayment("Bank");
            setAccountName("");
            setAmount("");
            setRefNumber("");
            setIssueCheckDate("");
            setSubject1("");
            setSubject2("");
            setSubject3("");
            setIsSubject2Disabled(true);
            setIsSubject3Disabled(true);
            setIsEditing(false);
            setTransactionToGetBack([]);
            setIdToAdd([]);
            setId(null);
            setEdit(false);
            setSelectedRow([]);
            setSelectedRowTransactions([]);
            window.onbeforeunload = null;
            fetchExistingData();
          });
        } else if (res.status === 201) {
          swal({
            title: "Opppss!",
            text: "Transaction Date is already posted in Cutoff. Please use other date",
            icon: "error",
            buttons: false,
            timer: 2000,
            dangerMode: true,
          });
        }
      } catch (error) {
        console.error("Error saving payment:", error);
        swal({
          title: "Something went wrong",
          text: "Please contact your support immediately",
          icon: "error",
          buttons: false,
          timer: 2000,
          dangerMode: true,
        });
      }
    } else {
      setValidated(false);
    }
    setValidated(true);
  };

  console.log(payableList);

  const handleRejected = async () => {
    const confirmed = await swal({
      title: "Are you sure you want to reject this?",
      text: "",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    });

    if (confirmed) {
      try {
        const res = await axios.post(
          `${BASE_URL}/payable/bulk/approve-reject`,
          {
            id,
            processDate,
            status: "Rejected",
            payableList,
            module,
            approvedBy: userLoggedID,
            floatPayment,
          },
        );

        if (res.status === 200) {
          swal({
            title: "Success",
            text: "Payable has been rejected successfully",
            icon: "success",
            buttons: false,
            timer: 2000,
            dangerMode: true,
          }).then(() => {
            navigate(
              `/purchases/${
                module === "local" ? "local-purchase" : "overseas-purchase"
              }?page=${searchParams.get("page")}`,
            );
          });
        }
      } catch (error) {
        if (error.response?.status === 401) {
          swal({
            icon: "error",
            // title: "Please contact your support",
            title: error.response.data.title,
            text: error.response.data.message,
          }); // test 1
        } else {
          console.error("Error saving payment:", error);
          swal({
            title: "Something went wrong",
            text: "Please contact your support immediately",
            icon: "error",
            buttons: false,
            timer: 2000,
            dangerMode: true,
          });
        }
      }
    } else {
      setValidated(false);
    }
    setValidated(true);
  };

  const handleApproved = async () => {
    const confirmed = await swal({
      title: "Are you sure you want to approve this?",
      text: "",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    });

    if (confirmed) {
      try {
        // Get the currency info
        const currency = allCurrency.find(
          (item) => item.id === payableBulk?.currency_id,
        );

        const res = await axios.post(
          `${BASE_URL}/payable/bulk/approve-reject`,
          {
            id,
            processDate,
            status: "Approved",
            floatPayment,
            payableList,
            transactionNumber: payableBulk?.transaction_number,
            module,
            approvedBy: userLoggedID,
            vendorId: payableBulk.vendor_id,
            currencyName: currency?.currency_name ?? "PHP",
            currencyRate: currency?.currency_rate ?? 1,
            dcConvertedAmount: parseNumber(overAllDiscount.convertedAmount),
          },
        );

        if (res.status === 200) {
          swal({
            title: "Success",
            text: "Payable has been approved successfully",
            icon: "success",
            buttons: false,
            timer: 2000,
            dangerMode: true,
          }).then(() => {
            navigate(
              `/purchases/local-purchase?page=${searchParams.get("page")}`,
            );
          });
        }
      } catch (error) {
        if (error.response?.status === 401) {
          swal({
            icon: "error",
            // title: "Please contact your support",
            title: error.response.data.title,
            text: error.response.data.message,
          }); // test 1
        } else {
          console.error("Error saving payment:", error);
          swal({
            title: "Something went wrong",
            text: "Please contact your support immediately",
            icon: "error",
            buttons: false,
            timer: 2000,
            dangerMode: true,
          });
        }
      }
    } else {
      setValidated(false);
    }
    setValidated(true);
  };

  const handleEditTransaction = () => {
    setIsEditing(true);
    setEdit(true);
  };

  const handleCancelEditTransaction = () => {
    swal({
      title: "Are you sure?",
      text: "Your changes will not be saved.",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (confirmed) => {
      if (confirmed) {
        // const payload = JSON.stringify({ id, idToAdd: transactionToGetBack });
        // const blob = new Blob([payload], { type: "application/json" });

        // navigator.sendBeacon(
        //   `${BASE_URL}/payable/getBackOrderListTransaction`,
        //   blob,
        // );

        // // setSelectedRow([]);
        // // setSelectedRowTransactions([]);
        // setIsEditing(false);
        // // setTransactionToGetBack([]);
        // // setIdToAdd([]);
        // // setId(null);
        // // setEdit(false);
        // fetchExistingData();
        // window.onbeforeunload = null;

        try {
          if (transactionToGetBack.length > 0) {
            await axios.post(
              `${BASE_URL}/payable/getBackOrderListTransaction`,
              { id, idToAdd: transactionToGetBack },
            );
          }

          setIsEditing(false);
          setEdit(false);
          setTransactionToGetBack([]);
          setRemoveIds([]);
          setRemoveIdsPaymentList([]);
          window.onbeforeunload = null;

          fetchExistingData();
        } catch (error) {
          console.error("Error cancelling edit:", error);
          swal(
            "Error",
            "Failed to revert changes properly. Please refresh the page.",
            "error",
          );
        }
      }
    });
  };

  if (isEditing === true) {
    window.onbeforeunload = (e) => {
      e.preventDefault();
      const payload = JSON.stringify({ id, idToAdd: transactionToGetBack });
      const blob = new Blob([payload], { type: "application/json" });

      navigator.sendBeacon(
        `${BASE_URL}/payable/getBackOrderListTransaction`,
        blob,
      );

      setIsEditing(false);
      window.onbeforeunload = null; // To clean up the event listener
      return "";
    };
  }

  // Subject 2 Options for dropdown select
  const subject2Options = subject2DataList.map((item) => ({
    value: item.id,
    label: item.subject_name,
    subject_type: item.subject_type,
  }));

  // Subject 3 Options for dropdown select
  const subject3Options = subject3DataList.map((item) => ({
    value: item.id,
    label: item.account_name,
  }));

  // Custom input for DatePicker: typed as MM/dd/yyyy and shown as Oct/10/2026
  // (TypedDateInput). Only a complete date reaches handleDateChange, so the
  // cutoff checks don't run on a half-typed date.
  const CustomInput = useMemo(() => {
    const Input = forwardRef(
      (
        {
          label,
          value,
          onClick,
          onChange,
          onBlur,
          onFocus,
          onKeyDown,
          generateYears,
          index,
          disabled,
          required,
          className,
          placeholder,
        },
        ref,
      ) => {
        let dynamicPlaceholder = placeholder;
        let displayValue = value || "";
        let cursorStyle = "text";
        let isReadView = false;

        if (label === "Process Date") {
          const isReadStatus =
            status === "Paid" ||
            (balance_now === 0 && status !== "For-Approval");

          const isApprovedStatus = ["Approved", "Partially-Paid"].includes(
            status,
          );

          if (isReadStatus) {
            isReadView = true;
            displayValue = "";
            dynamicPlaceholder = "Click the icon to view payment history";
            cursorStyle = "default";
          } else if (isApprovedStatus) {
            if (!hasSelectedNewProcessDate) {
              displayValue = "";
              dynamicPlaceholder = "Click to Select Process Date";
            }
          }
        }

        const isRowDisabled =
          disabled || // Apply the passed disabled prop
          (index !== undefined
            ? editableRow !== index
            : (label === "Process Date" || label === "Issue Check Date") &&
                status === "For-Approval"
              ? !isEditing
              : isPaymentInputDisabled);

        cursorStyle = isRowDisabled ? "not-allowed" : cursorStyle;

        const inputClassName =
          `form-control p-2 w-100 ${className || ""}`.trim();

        const handleClick = (e) => {
          if (isRowDisabled || cursorStyle === "default") return;
          if (onClick) onClick(e);

          let dateYear = new Date().getFullYear();
          if (value) {
            const parsed = new Date(value);
            if (!isNaN(parsed.getTime())) {
              dateYear = parsed.getFullYear();
            }
          }

          if (generateYears && typeof generateYears === "function") {
            generateYears(dateYear);
          }
        };

        // Payment history view: nothing to type
        if (isReadView) {
          return (
            <input
              type="text"
              className={inputClassName}
              style={{ cursor: cursorStyle, caretColor: "transparent" }}
              onClick={handleClick}
              onKeyDown={onKeyDown}
              value={displayValue}
              ref={ref}
              placeholder={dynamicPlaceholder}
              readOnly
              required={required !== undefined ? required : true}
              disabled={isRowDisabled}
            />
          );
        }

        return (
          <TypedDateInput
            className={inputClassName}
            style={{ cursor: cursorStyle }}
            onClick={handleClick}
            // Clearing the text doesn't clear the date: it snaps back on blur
            onChange={(e) => e.target.value && onChange(e)}
            onBlur={onBlur}
            onFocus={onFocus}
            onKeyDown={onKeyDown}
            value={displayValue}
            ref={ref}
            placeholder={dynamicPlaceholder}
            required={required !== undefined ? required : true}
            disabled={isRowDisabled}
          />
        );
      },
    );

    Input.displayName = "CustomInput";
    return Input;
  }, [
    status,
    balance_now,
    hasSelectedNewProcessDate,
    editableRow,
    isEditing,
    isPaymentInputDisabled,
  ]);

  // function to handle currency rate formatting
  const handleCurrencyRateChange = (e) => {
    let inputValue = e.target.value.replace(/[^0-9.]/g, "");
    if ((inputValue.match(/\./g) || []).length > 1) return;
    let [integerPart, decimalPart] = inputValue.split(".");
    if (integerPart) {
      integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    let formattedValue =
      decimalPart !== undefined ? `${integerPart}.${decimalPart}` : integerPart;

    setCurrencyRate(formattedValue);
  };

  const handleItemDiscountChange = (index, key, value) => {
    setPayableList((prev) => {
      const updated = [...prev];
      updated[index] = {
        ...updated[index],
        [key]: value,
      };
      return updated;
    });
  };

  const checkEditPayment = () => {
    if (editableRow !== null) {
      swal({
        icon: "warning",
        title: "Payment Edit in Progress",
        text: "Please click (✔) or (✖) buttons of your current payment edit before performing other actions.",
      });
      return true;
    }
    return false;
  };

  const handleEditClick = (index, data) => {
    if (checkEditPayment()) return;
    setEditableRow(index);
    setEditedData({ ...data });
  };

  const handleEditAmountValue = (val) => {
    if (val === "" || val === ".") {
      setEditedData((prev) => ({ ...prev, amount: val }));
      return;
    }

    const numericValue = parseFloat(val);

    const sumOfOtherPayments = floatPayment.reduce((acc, data, i) => {
      if (i === editableRow) return acc;
      return acc + parseFloat(String(data.amount || 0).replace(/,/g, ""));
    }, 0);

    const maxAllowed = toPayAmount - sumOfOtherPayments;

    if (numericValue > maxAllowed) {
      swal({
        icon: "warning",
        title: "Amount Adjusted",
        text: `Please input not greater than the balance. The amount adjusted to match your remaining balance (${truncateToTwoDecimals(maxAllowed)}).`,
        buttons: false,
        timer: 2000,
      });
      setEditedData((prev) => ({ ...prev, amount: maxAllowed.toString() }));
      return;
    }

    setEditedData((prev) => ({ ...prev, amount: val }));
  };

  const handleEditIssuedDate = async (date, index) => {
    if (editableRow !== index) return;

    const previousDate = editedData.issuedDate;

    const safeSetter = (val) => {
      setEditedData((prev) => ({
        ...prev,
        issuedDate: val === "" ? previousDate : val,
      }));
    };

    const isPosted = await postedCutoffValidation(
      date,
      safeSetter,
      "Issued Check Date",
    );
    if (isPosted) return;

    setEditedData((prev) => ({ ...prev, issuedDate: date }));
  };

  const handleSaveEdit = async (index) => {
    if (editableRow === index) {
      const originalCheck = floatPayment[index]?.checkNumber || "";
      if (
        editedData.checkNumber &&
        editedData.checkNumber.trim() !== originalCheck.trim() &&
        !(await validateCheckNumbers(editedData.checkNumber, {
          pending: floatPayment
            .filter((payment, i) => i !== index && !payment.isDeleted)
            .map((payment) => payment.checkNumber),
        }))
      )
        return;

      setFloatPayment((prevPayments) => {
        const updatedPayments = prevPayments.map((payment, i) =>
          i === index ? { ...payment, ...editedData } : payment,
        );
        return updatedPayments;
      });
      setEditableRow(null);
    }
  };

  const handleProcessDate = async (date) => {
    if (checkEditPayment()) return;

    const toDateOnly = (d) => {
      const r = new Date(d);
      r.setHours(0, 0, 0, 0);
      return r;
    };
    if (issueCheckDate && toDateOnly(date) > toDateOnly(issueCheckDate)) {
      swal({
        icon: "warning",
        title: "Invalid Process Date",
        text: "Process Date cannot be greater than the Maturity Date.",
        buttons: false,
        timer: 2500,
      });
      return;
    }

    const previousDate = processDate;

    const isPosted = await postedCutoffValidation(
      date,
      (val) => {
        setProcessDate(val === "" ? previousDate : val);
      },
      "Process Date",
    );

    if (isPosted) {
      setHasSelectedNewProcessDate(false);
      return;
    }

    setProcessDate(date);
    setHasSelectedNewProcessDate(true);
    warnIfNoCutoff(date, "Process Date");
  };

  const handleIssueCheckDate = async (date) => {
    if (checkProcessDateForPayment()) return;
    if (checkEditPayment()) return;

    const toDateOnly = (d) => {
      const r = new Date(d);
      r.setHours(0, 0, 0, 0);
      return r;
    };
    if (processDate && toDateOnly(date) < toDateOnly(processDate)) {
      swal({
        icon: "warning",
        title: "Invalid Maturity Date",
        text: "Maturity Date cannot be earlier than the Process Date.",
        buttons: false,
        timer: 2500,
      });
      return;
    }

    const previousDate = issueCheckDate;

    const isPosted = await postedCutoffValidation(
      date,
      (val) => {
        setIssueCheckDate(val === "" ? previousDate : val);
      },
      "Issue Check Date",
    );

    if (isPosted) {
      return;
    }

    setIssueCheckDate(date);
    warnIfNoCutoff(date, "Issue Check Date");
  };

  const checkProcessDateForPayment = () => {
    if (status !== "For-Approval") {
      if (!hasSelectedNewProcessDate || !processDate) {
        swal({
          icon: "warning",
          title: "Process Date Required",
          text: "Please select a process date first before selecting payment details.",
          buttons: false,
          timer: 2500,
        });
        return true;
      }
    } else {
      if (!processDate) {
        swal({
          icon: "warning",
          title: "Process Date Required",
          text: "Please ensure the Process Date is filled out before adding a payment.",
          buttons: false,
          timer: 2500,
        });
        return true;
      }
    }
    return false;
  };

  useEffect(() => {
    if (selectedPayment === "Cash") {
      if (processDate) {
        // Sync maturity date with the chosen process date
        setIssueCheckDate(processDate);
      } else {
        // Fallback to today if no process date is selected
        const currentDate = dateToday();
        setIssueCheckDate(currentDate);
        setProcessDate(currentDate);
      }
      setHasSelectedNewProcessDate(true);
    }
  }, [selectedPayment, processDate]);
  // Make sure to add processDate to the dependency array

  return (
    <div>
      <div className="w-100 p-2 d-flex flex-row justify-content-between">
        <div className="w-100 d-flex flex-row justify-content-between">
          <div className="d-flex flex-column title-custom">
            <span className="fs-3">
              <Link
                to={`/purchases/${
                  module === "local" ? "local-purchase" : "overseas-purchase"
                }`}
                state={{ fromViewPage: true }}
                className="text-dark mx-2"
              >
                <i class="fa-solid fa-arrow-left"></i>
              </Link>
              PAYABLE OVERVIEW
            </span>
            <p className="fs-6">
              Status:{" "}
              <span
                style={{
                  color:
                    status === "For-Approval"
                      ? "orange"
                      : status === "Approved"
                        ? "green"
                        : "red",
                  textTransform: "uppercase",
                }}
              >
                {status}
              </span>
            </p>
          </div>
        </div>
      </div>
      <Container fluid>
        <Row className="p-2">
          <Col sm>
            <span>Transaction Number</span>
            <Form.Control
              type="text"
              name="transactionNumber"
              id="transactionNumber"
              value={payableBulk?.transaction_number || ""}
              className="p-2 pointer-events-none"
              readOnly
            />
          </Col>
          <Col sm>
            <span>Process Date</span>
            <InputGroup className="mb-2">
              {status !== "For-Approval" && (
                <InputGroup.Text
                  className="cursor-pointer"
                  onClick={() => setShowHistoryModal(true)}
                  title="View Collection History"
                >
                  <i className="fas fa-history"></i>
                </InputGroup.Text>
              )}
              <CustomDatePicker
                label={"Process Date"}
                selected={processDate ? new Date(processDate) : ""}
                handleDateChange={handleProcessDate}
                CustomInput={CustomInput}
                isRequired={true}
                validated={validated}
                //disabled={selectedPayment === "Cash"} // Add this line
                maxDate={
                  issueCheckDate
                    ? new Date(
                        new Date(issueCheckDate).setHours(23, 59, 59, 999),
                      )
                    : undefined
                }
              />
            </InputGroup>
            <BulkPayableHistoryModal
              show={showHistoryModal}
              onHide={() => setShowHistoryModal(false)}
              bulkPayableId={id}
            />
          </Col>
        </Row>
        <Row className="p-2">
          <Col sm>
            <span>Supplier</span>
            <InputGroup className="mb-2">
              <Form.Select
                className="p-2"
                required
                disabled
                value={payableBulk.vendor_id}
              >
                <option disabled selected value="">
                  Select Supplier
                </option>
                {vendorMap.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </Form.Select>
            </InputGroup>
          </Col>
          <Col sm>
            <span>Currency</span>
            {/* {currency && currency !== "11111111-1111-1111-1111-111111111111" ? (
              <span className="text-muted mb-1">
                {" | "}
                Current Rate: {currencyRate}
              </span>
            ) : null} */}
            <InputGroup className="mb-2">
              <Form.Select
                className="p-2"
                required
                disabled
                value={payableBulk.currency_id}
              >
                <option disabled selected value="">
                  Select Currency
                </option>
                {allCurrency.map((option) => (
                  <option key={option.id} value={option.id}>
                    {option.currency_name}
                  </option>
                ))}
              </Form.Select>
            </InputGroup>
          </Col>
          {payableBulk.currency_id &&
          payableBulk.currency_id !== "11111111-1111-1111-1111-111111111111" ? (
            <Col sm className="d-none">
              <span>Currency Rate</span>
              <Form.Control
                type="text"
                name=""
                id=""
                className="p-2"
                required
                onChange={handleCurrencyRateChange}
                value={currencyRate}
                disabled={!isEditing}
              />
            </Col>
          ) : null}
        </Row>

        <Row className="p-2">
          <Col sm>
            <span>Payable Balance</span>
            <InputGroup className="mb-2">
              <InputGroup.Text>
                {currencySymbol[currencyName] || ""}
              </InputGroup.Text>
              <Form.Control
                type="text"
                className="p-2 pointer-events-none"
                id="payable_balance"
                value={truncateToTwoDecimals(totalAmountSum)}
                readOnly
              />
            </InputGroup>
          </Col>
          <Col sm>
            <div className="p-0">
              <span>Overall Closed Discount</span>
              <InputGroup className="mb-2">
                <InputGroup.Text>
                  {currencySymbol[currencyName] || ""}
                </InputGroup.Text>
                <Form.Control
                  type="text"
                  className="form-control p-2 pointer-events-none"
                  id="overallDiscountAmount"
                  value={truncateToTwoDecimals(overAllDiscount.convertedAmount)}
                  readOnly
                />
              </InputGroup>
            </div>
          </Col>
        </Row>
      </Container>
      <Container fluid>
        <div className="w-100 d-flex align-items-center mt-3 p-2">
          <h5>Order List</h5>
          <hr className="flex-grow-1 mx-3" />
        </div>
        <div className="w-100 mt-2 p-2 new-item-custom scrollable-contents">
          <Table bordered hover responsive className="fixed-inputs-table">
            <thead className="table-light">
              <tr>
                <th className="p-2">Transactions ID</th>
                <th className="p-2">Remarks</th>
                <th className="p-2">Purchase Date</th>
                <th className="p-2">Due Date</th>
                <th className="p-2">Amount</th>
                <th className="p-2">Closed Discount</th>
                {isEditing && <th className="p-2">Action</th>}
              </tr>
            </thead>
            {payableList.length > 0 ? (
              <tbody>
                {payableList.map((item, index) => (
                  <tr key={index}>
                    <td className="d-none">
                      <Form.Control
                        value={item?.payable?.transaction_id || "---"}
                        type="text"
                        readOnly
                      />
                    </td>
                    <td>
                      <Form.Control
                        value={item?.payable?.client_transaction_id || "---"}
                        type="text"
                        className="pointer-events-none"
                        readOnly
                      />
                    </td>
                    <td>
                      <Form.Control
                        value={item?.payable?.description || "---"}
                        type="text"
                        className="pointer-events-none"
                        readOnly
                      />
                    </td>
                    <td>
                      <DatePicker
                        selected={item?.payable?.createdAt}
                        dateFormat="MMM/dd/yyyy"
                        className="form-control pointer-events-none"
                        readOnly
                      />
                    </td>
                    <td>
                      <DatePicker
                        selected={item?.payable?.due_date}
                        dateFormat="MMM/dd/yyyy"
                        className="form-control pointer-events-none"
                        readOnly
                      />
                    </td>
                    <td>
                      <Form.Control
                        value={truncateToTwoDecimals(item?.totalAmount)}
                        type="text"
                        className="pointer-events-none"
                        readOnly
                      />
                    </td>
                    <td>
                      <InputGroup>
                        <InputGroup.Text
                          id={`discount-type-${index}`}
                          style={{
                            cursor: isEditing ? "pointer" : "default",
                            userSelect: "none",
                          }}
                          onClick={() => {
                            if (!selectedVendorId || !isEditing) return;
                            const newType =
                              item.closedDiscountType === "percent"
                                ? "amount"
                                : "percent";
                            let newValue = item.closedDiscountValue;

                            if (
                              newType === "percent" &&
                              parseFloat(newValue) >= 100
                            ) {
                              newValue = 100;
                            }

                            setPayableList((prev) => {
                              const updated = [...prev];
                              updated[index] = {
                                ...updated[index],
                                closedDiscountType: newType,
                                closedDiscountValue: newValue,
                              };
                              return updated;
                            });
                          }}
                        >
                          {item.closedDiscountType === "percent"
                            ? "%"
                            : currencySymbol[currencyName] || ""}
                        </InputGroup.Text>
                        <NumberInDecimals
                          className="form-control p-2"
                          disabled={!selectedVendorId || !isEditing}
                          value={item.closedDiscountValue || ""}
                          placeholder="0"
                          decimals={2}
                          max={
                            item.closedDiscountType === "percent"
                              ? 100
                              : parseFloat(item.totalAmount)
                          }
                          onChange={(val) =>
                            handleItemDiscountChange(
                              index,
                              "closedDiscountValue",
                              val,
                            )
                          }
                        />
                        <InputGroup.Text
                          id={`discount-operator-${index}`}
                          style={{
                            cursor: isEditing ? "pointer" : "default",
                            userSelect: "none",
                          }}
                          onClick={() => {
                            if (!selectedVendorId || !isEditing) return;
                            const newOp =
                              item.closedDiscountOperator === "+" ? "-" : "+";
                            handleItemDiscountChange(
                              index,
                              "closedDiscountOperator",
                              newOp,
                            );
                          }}
                        >
                          {item.closedDiscountOperator || "+"}
                        </InputGroup.Text>
                      </InputGroup>
                    </td>
                    {isEditing && (
                      <td>
                        <Button
                          size="sm"
                          variant="outline-danger"
                          onClick={() => deleteItem(item, index)}
                          disabled={
                            payableList.length <= 1 ||
                            (payableList.length > 1 &&
                              !payableList[1].payable?.id)
                          }
                        >
                          <i className="fa-solid fa-trash-can"></i>
                        </Button>
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            ) : (
              <caption className="text-center mt-3">
                There are no records to display
              </caption>
            )}
          </Table>
        </div>
        <div className="w-100 d-flex justify-content-end mt-2">
          {isEditing && (
            <Button
              size="sm"
              variant="primary"
              type="button"
              onClick={addNewItem}
            >
              New Item
            </Button>
          )}
        </div>
      </Container>

      <Container fluid>
        <div className="w-100 d-flex align-items-center mt-3 p-2">
          <h5>Payment</h5>
          <hr className="flex-grow-1 mx-3" />
        </div>
        <Row className="w-100 p-2 mt-1">
          <Col xs={12} md={4} className="p-2">
            <div className="w-100 border shadow-sm p-3 rounded">
              <div className="w-100 d-flex flex-column payment-card border-bottom pb-2 mb-3">
                <span className="fw-bold">Payment Method</span>
                {(status === "Approved" || status === "Partially-Paid") &&
                  !hasSelectedNewProcessDate && (
                    <span className="text-danger small mt-1">
                      Please select a process date first at the top *
                    </span>
                  )}
              </div>
              <Form validated={validated} onSubmit={handleAddPayment}>
                <Form.Group className="mb-3" controlId="payWith">
                  <Form.Label className="fw-bold">Pay With:</Form.Label>
                  <div className="d-flex">
                    <Form.Check
                      type="radio"
                      name="paymentType"
                      id="bank"
                      label="Bank"
                      value="Bank"
                      disabled={isPaymentInputDisabled}
                      checked={selectedPayment === "Bank"}
                      onChange={handlePaymentMethod}
                      className="me-3"
                    />
                    <Form.Check
                      type="radio"
                      name="paymentType"
                      id="cash"
                      label="Cash"
                      disabled={isPaymentInputDisabled}
                      value="Cash"
                      checked={selectedPayment === "Cash"}
                      onChange={handlePaymentMethod}
                      className="me-3"
                    />
                  </div>
                  {/** 
                  <div className="mt-2">
                    <Form.Check
                      type="checkbox"
                      disabled={isPaymentInputDisabled}
                      checked={onlinePaymentCheckbox}
                      onChange={handleOnlineCheck}
                      label="Online"
                    />
                  </div>
                  */}
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold">
                    Step 1 / Subject <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Select
                    className="form-select"
                    onChange={handleSubject1Change}
                    value={subject1}
                    required
                    disabled={isPaymentInputDisabled}
                  >
                    <option value="" selected disabled>
                      Select Subject 1
                    </option>
                    <option value="Account-List">Account-List</option>
                    <option value="Asset Account">Asset Account</option>
                    <option value="Liabilities Account">
                      Liabilities Account
                    </option>
                    <option value="Owner's Equity Account">
                      Owner's Equity Account
                    </option>
                  </Form.Select>
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold">
                    Step 2 / Subject <span className="text-danger">*</span>
                  </Form.Label>
                  {/* <Form.Select
                      className="form-select"
                      onChange={(e) =>
                        handleSubject2Change(
                          e,
                          e.target.options[e.target.selectedIndex].getAttribute(
                            "data-subject-type"
                          )
                        )
                      }
                      value={subject2}
                      disabled={isSubject2Disabled}
                      required
                    >
                      <option value="" selected disabled>
                        Select Subject 2
                      </option>
                      {subject2DataList.map((option) => (
                        <option
                          key={option.id}
                          value={option.id}
                          data-subject-type={option.subject_type}
                        >
                          {option.subject_name}
                        </option>
                      ))}
                    </Form.Select> */}
                  <Select
                    options={subject2Options}
                    value={subject2}
                    onChange={(selectedOption) =>
                      handleSubject2Change(selectedOption)
                    }
                    placeholder={`Select Subject 2`}
                    styles={themeSelectStyles(
                      selectCustomStyles(subject2, validated),
                    )}
                    isDisabled={isSubject2Disabled}
                    required
                    isSearchable
                  />
                </Form.Group>

                <Form.Group className="mb-3" controlId="accountName">
                  <Form.Label className="fw-bold">
                    Accounts <span className="text-danger">*</span>
                  </Form.Label>
                  {/* <Form.Select
                      value={subject3}
                      className="p-2"
                      onChange={handleAccountChange}
                      required={selectedPayment !== "Online"}
                      disabled={isSubject3Disabled}
                    >
                      <option value="" disabled>
                        Select Account name
                      </option>
                      {subject3DataList.map((data) => (
                        <option key={data.id} value={data.id}>
                          {data.account_name}
                        </option>
                      ))}
                    </Form.Select> */}
                  <Select
                    options={subject3Options}
                    value={subject3}
                    onChange={handleAccountChange}
                    placeholder={`Select Account name`}
                    styles={themeSelectStyles(
                      selectCustomStyles(subject3, validated),
                    )}
                    isDisabled={isSubject3Disabled}
                    required={selectedPayment !== "Online"}
                    isSearchable
                  />
                </Form.Group>

                {selectedPayment === "Bank" && !onlinePaymentCheckbox && (
                  <Form.Group className="mb-3" controlId="checkNumber">
                    <Form.Label>Check #</Form.Label>
                    <Form.Control
                      type="text"
                      className="p-2"
                      readOnly={isPaymentInputDisabled}
                      placeholder="000000-000-0000"
                      value={checkNumber}
                      maxLength={15}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value.length <= 15) {
                          setCheckNumber(value);
                        }
                      }}
                    />
                    <CheckNumberError
                      value={checkNumber}
                      disabled={selectedPayment !== "Bank"}
                      pending={floatPayment
                        .filter((payment) => !payment.isDeleted)
                        .map((payment) => payment.checkNumber)}
                    />
                  </Form.Group>
                )}

                {onlinePaymentCheckbox && (
                  <Form.Group className="mb-3" controlId="checkNumber">
                    <Form.Label>Reference #</Form.Label>
                    <Form.Control
                      type="text"
                      className="p-2"
                      readOnly={isPaymentInputDisabled}
                      placeholder="000000-000-0000"
                      value={refNumber}
                      onChange={(e) => setRefNumber(e.target.value)}
                    />
                  </Form.Group>
                )}

                {onlinePaymentCheckbox && (
                  <Form.Group className="mb-3" controlId="online">
                    <Form.Label>Online Wallet Remarks</Form.Label>
                    <Form.Control
                      type="text"
                      className="p-2"
                      readOnly={isPaymentInputDisabled}
                      value={onlineWalletRemarks}
                      placeholder="Description"
                      onChange={(e) => setOnlineWalletRemarks(e.target.value)}
                    />
                  </Form.Group>
                )}

                <Form.Group className="mb-3" controlId="date">
                  <Form.Label>
                    Issue Check Date (Maturity Date){" "}
                    <span className="text-danger">*</span>
                  </Form.Label>
                  <CustomDatePicker
                    label={"Issue Check Date"}
                    selected={issueCheckDate ? new Date(issueCheckDate) : ""}
                    handleDateChange={handleIssueCheckDate}
                    CustomInput={CustomInput}
                    isRequired={true}
                    validated={validated}
                    disabled={
                      isPaymentInputDisabled || selectedPayment === "Cash"
                    } // Update this line
                    minDate={
                      processDate
                        ? new Date(new Date(processDate).setHours(0, 0, 0, 0))
                        : undefined
                    }
                  />
                </Form.Group>

                <Form.Group className="mb-3" controlId="amount">
                  <Form.Label>
                    Amount <span className="text-danger">*</span>
                  </Form.Label>
                  <InputGroup>
                    <InputGroup.Text>
                      {currencySymbol[currencyName] || ""}
                    </InputGroup.Text>
                    <NumberInDecimals
                      className="form-control p-2"
                      required
                      placeholder="0.00"
                      value={amount}
                      decimals={2}
                      onChange={handleAmountValue}
                      disabled={isPaymentInputDisabled}
                    />
                  </InputGroup>
                  {accessType === "Management" && accountName && (
                    <span>
                      Account Balance:{" "}
                      <strong>{truncateToTwoDecimals(bankAmount)}</strong>
                    </span>
                  )}
                </Form.Group>

                <Button
                  type="submit"
                  disabled={isPaymentInputDisabled}
                  variant="primary"
                  className="w-100 p-2"
                >
                  Add Payment
                </Button>
              </Form>
            </div>
          </Col>
          <Col xs={12} md={8} className="p-2 d-flex flex-column">
            <div className="w-100 border shadow-sm p-2 rounded mb-2">
              <div className="w-100 d-flex flex-column payment-card border-bottom pb-2 mb-3">
                <span className="fw-bold">Payment List</span>
              </div>
              <div className="mt-3">
                <Table bordered hover responsive className="fixed-inputs-table">
                  <thead>
                    <tr>
                      <th className="p-2">Type</th>
                      <th className="p-2">Transaction Number</th>
                      <th className="p-2">Account Name</th>
                      <th className="p-2">Amount</th>
                      <th className="p-2">Check Number</th>
                      {/* <th className="p-2">Ref Number</th> */}
                      <th className="p-2">Maturity Date</th>
                      {/* <th className="p-2">Process Date</th> */}
                      {isEditing && <th className="p-2">Action</th>}
                    </tr>
                  </thead>
                  {floatPayment.some(
                    (data) =>
                      data.status !== "Rejected" && data.isDeleted !== true,
                  ) ? (
                    <tbody>
                      {floatPayment.map(
                        (data, i) =>
                          data.status !== "Rejected" &&
                          data.isDeleted !== true && (
                            <tr key={i}>
                              <td>{data.paymentMethod || "---"}</td>
                              <td>{data.transactionNumber || "---"}</td>
                              <td>
                                {data.accountList_id === ""
                                  ? "---"
                                  : data.accountName}
                              </td>
                              <td>
                                {editableRow === i ? (
                                  <InputGroup>
                                    <InputGroup.Text>
                                      {currencySymbol[currencyName] || ""}
                                    </InputGroup.Text>
                                    <NumberInDecimals
                                      className="form-control"
                                      value={editedData.amount}
                                      decimals={2}
                                      onChange={handleEditAmountValue}
                                      onKeyDown={(e) =>
                                        e.key === "Enter" && handleSaveEdit(i)
                                      }
                                    />
                                  </InputGroup>
                                ) : (
                                  <InputGroup>
                                    <InputGroup.Text>
                                      {currencySymbol[currencyName] || ""}
                                    </InputGroup.Text>
                                    <Form.Control
                                      type="text"
                                      className="pointer-events-none"
                                      value={truncateToTwoDecimals(data.amount)}
                                      readOnly
                                    />
                                  </InputGroup>
                                )}
                              </td>
                              <td>
                                {editableRow === i ? (
                                  <>
                                    <Form.Control
                                      type="text"
                                      value={editedData.checkNumber}
                                      onChange={(e) =>
                                        setEditedData((prev) => ({
                                          ...prev,
                                          checkNumber: e.target.value,
                                        }))
                                      }
                                      onKeyDown={(e) =>
                                        e.key === "Enter" && handleSaveEdit(i)
                                      }
                                      placeholder="---"
                                    />
                                    <CheckNumberError
                                      value={editedData.checkNumber}
                                      ignore={[data.checkNumber]}
                                      pending={floatPayment
                                        .filter(
                                          (payment, j) =>
                                            j !== i && !payment.isDeleted,
                                        )
                                        .map((payment) => payment.checkNumber)}
                                    />
                                  </>
                                ) : (
                                  <Form.Control
                                    type="text"
                                    className="pointer-events-none"
                                    value={data.checkNumber || "---"}
                                    readOnly
                                  />
                                )}
                              </td>
                              {/* <td>
                                {data.refNumber === null || ""
                                  ? "--"
                                  : data.refNumber}
                          </td> */}
                              <td>
                                <CustomDatePicker
                                  index={i}
                                  label={"Issued Check Date"}
                                  selected={
                                    editableRow === i
                                      ? editedData.issuedDate
                                        ? new Date(editedData.issuedDate)
                                        : null
                                      : data.issuedDate
                                        ? new Date(data.issuedDate)
                                        : null
                                  }
                                  handleDateChange={(date) =>
                                    handleEditIssuedDate(date, i)
                                  }
                                  CustomInput={CustomInput}
                                  isRequired={true}
                                  validated={validated}
                                  disabled={data.paymentMethod === "Cash"}
                                />
                              </td>
                              {/* <td>
                              <DatePicker
                                selected={processDate}
                                dateFormat="MMM/dd/yyyy"
                                className="form-control"
                                readOnly
                              />
                            </td> */}
                              {isEditing && (
                                <td>
                                  {editableRow === i ? (
                                    <>
                                      <Button
                                        size="sm"
                                        variant="outline-success"
                                        className="me-1"
                                        onClick={() => handleSaveEdit(i)}
                                        disabled={balance_now < 0}
                                        title="Save Changes"
                                      >
                                        <i className="fa-solid fa-check"></i>
                                      </Button>
                                      <Button
                                        size="sm"
                                        variant="outline-secondary"
                                        onClick={() => setEditableRow(null)}
                                        title="Cancel"
                                      >
                                        <i className="fa-solid fa-xmark"></i>
                                      </Button>
                                    </>
                                  ) : (
                                    <>
                                      <Button
                                        size="sm"
                                        variant="outline-primary"
                                        className="me-1"
                                        onClick={() => handleEditClick(i, data)}
                                        title="Edit Payment"
                                      >
                                        <i className="fa-solid fa-edit"></i>
                                      </Button>
                                      <Button
                                        size="sm"
                                        variant="outline-danger"
                                        onClick={() =>
                                          handleDeletePayment(i, data)
                                        }
                                        title="Delete Payment"
                                      >
                                        <i className="fa-solid fa-trash"></i>
                                      </Button>
                                    </>
                                  )}
                                </td>
                              )}
                            </tr>
                          ),
                      )}
                    </tbody>
                  ) : (
                    <caption className="text-center mt-3">
                      There are no records to display
                    </caption>
                  )}
                </Table>
              </div>
            </div>
            <div className="w-100 border shadow-sm p-2 rounded">
              <div className="w-100 d-flex flex-column payment-card border-bottom pb-2 mb-3">
                <span className="fw-bold">Balance Details</span>
              </div>
              <Row>
                {/* Left Side: Order List Summary */}
                <Col xs={12} lg={5} className="mb-4 mb-lg-0">
                  <div className="w-100 d-flex flex-row justify-content-between p-2">
                    <span>Gross Amount :</span>
                    <span className="text-secondary">
                      {`${currencySymbol[currencyName] || ""} ${truncateToTwoDecimals(totalAmountSum)}`}
                    </span>
                  </div>
                  <div className="w-100 d-flex flex-row justify-content-between p-2">
                    <span>Overall Discount :</span>
                    <span
                      className={`${
                        overAllDiscount.convertedAmount > 0
                          ? "text-danger"
                          : overAllDiscount.convertedAmount < 0
                            ? "text-success"
                            : "text-secondary"
                      }`}
                    >
                      {`${currencySymbol[currencyName] || ""} ${truncateToTwoDecimals(Math.abs(overAllDiscount.convertedAmount))}`}
                    </span>
                  </div>
                  <div className="w-100 d-flex flex-row justify-content-between p-3 mt-3 total-amount-container align-items-center rounded">
                    <span className="text-white">Payable Balance</span>
                    <span className="text-white text-underline">
                      {`${currencySymbol[currencyName] || ""} ${truncateToTwoDecimals(balance_now)}`}
                    </span>
                  </div>
                </Col>

                {/* Spacer block (hidden on mobile, visible on large screens) */}
                <Col lg={2} className="d-none d-lg-block"></Col>

                <Col xs={12} lg={5}>
                  <div className="w-100 d-flex flex-row justify-content-between p-2">
                    <span>Cash</span>
                    <span className="text-secondary">
                      {truncateToTwoDecimals(totalCashPaid)}
                    </span>
                  </div>
                  <div className="w-100 d-flex flex-row justify-content-between p-2">
                    <span>Bank</span>
                    <span className="text-secondary">
                      {truncateToTwoDecimals(totalBankPaid)}
                    </span>
                  </div>
                  <div className="w-100 d-flex flex-row justify-content-between p-2">
                    <span>Check</span>
                    <span className="text-secondary">
                      {truncateToTwoDecimals(totalCheckPaid)}
                    </span>
                  </div>
                  <div className="w-100 d-flex flex-row justify-content-between p-2">
                    <span>Online</span>
                    <span className="text-secondary">
                      {truncateToTwoDecimals(totalOnlinePaid)}
                    </span>
                  </div>
                  <div className="w-100 d-flex flex-row justify-content-between p-3 mt-3 total-amount-container align-items-center rounded">
                    <span className="text-white">Total Payment</span>
                    <span className="text-white text-underline">
                      {`${currencySymbol[currencyName] || ""} ${truncateToTwoDecimals(totalPayment)}`}
                    </span>
                  </div>
                </Col>
              </Row>
            </div>
            <Row className="mt-4">
              <Col sm></Col>
              <Col sm></Col>
              <Col sm className="d-flex flex-row mb-2 w-100">
                {isEditing ? (
                  <>
                    <Button
                      variant="outline-secondary"
                      className="w-100 me-3"
                      onClick={handleCancelEditTransaction}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="primary"
                      className="w-100"
                      type="button"
                      disabled={totalAmountSum < 0}
                      onClick={handleSavePayment}
                    >
                      Update
                    </Button>
                  </>
                ) : (
                  <>
                    {authrztn.includes("LocalPurchase-Edit") &&
                      status === "For-Approval" && (
                        <div className="w-100 me-3">
                          <Button
                            variant="outline-primary"
                            className="w-100 px-4"
                            type="button"
                            onClick={handleEditTransaction}
                          >
                            Edit
                          </Button>
                        </div>
                      )}
                    {authrztn.includes("LocalPurchase-Approve") &&
                      status === "For-Approval" && (
                        <>
                          <Button
                            variant="outline-danger"
                            className="w-100 me-3"
                            type="button"
                            onClick={handleRejected}
                            disabled={isCutoffPosted || !isCutoffExists}
                          >
                            Reject
                          </Button>
                          <Button
                            variant="outline-success"
                            type="button"
                            className="w-100"
                            onClick={handleApproved}
                            disabled={isCutoffPosted || !isCutoffExists}
                            // disabled={
                            //   Math.max(
                            //     0,
                            //     parseFloat(totalAmountSum.toFixed(2))
                            //   ) !==
                            //     parseFloat(
                            //       [
                            //         ...paymentList.map(
                            //           (p) => parseFloat(p.amount) || 0
                            //         ),
                            //         ...floatPayment.map(
                            //           (f) =>
                            //             parseFloat(f.amountInputted) || 0
                            //         ),
                            //       ]
                            //         .reduce(
                            //           (total, amount) => total + amount,
                            //           0
                            //         )
                            //         .toFixed(2)
                            //     ) || isCutoffPosted
                            // }
                          >
                            Approve
                          </Button>
                        </>
                      )}
                  </>
                )}
              </Col>

              {/* {Math.max(
                  0,
                  parseFloat(totalAmountSum.toFixed(2))
                ) !==
                  parseFloat(
                    [
                      ...paymentList.map(
                        (p) => parseFloat(p.amount) || 0
                      ),
                      ...floatPayment.map(
                        (f) => parseFloat(f.amountInputted) || 0
                      ),
                    ]
                      .reduce(
                        (total, amount) => total + amount,
                        0
                      )
                      .toFixed(2)
                  ) && (
                  <span
                    className={`text-danger ${
                      isCutoffPosted && "d-none"
                    }`}
                    style={{
                      fontSize: "0.9rem",
                    }}
                  >
                    Please Complete the Payment Before
                    Proceeding.
                  </span>
                )} */}

              {(authrztn.includes("LocalPurchase-Edit") ||
                authrztn.includes("LocalPurchase-Approve")) &&
                isCutoffPosted && (
                  <div>
                    <p className="text-danger">
                      Action is prohibited as the Purchase date has already been
                      posted.
                    </p>
                  </div>
                )}

              {(authrztn.includes("LocalPurchase-Edit") ||
                authrztn.includes("LocalPurchase-Approve")) &&
                !isCutoffExists && (
                  <div>
                    <p className="text-danger">
                      Action is prohibited as the Purchase date has not been
                      created.
                    </p>
                  </div>
                )}
            </Row>
          </Col>
        </Row>
      </Container>

      <Modal
        show={show}
        size="xl"
        onHide={() => {
          setFilterColumn("all");
          setSearchTerm("");
          handleClose();
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Payable List</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row className="mb-3">
            <InputGroup>
              <Form.Control
                type="text"
                placeholder="Search"
                value={searchTerm}
                onChange={(e) => {
                  let input = e.target.value;

                  // Remove commas
                  const raw = String(input).replace(/,/g, "");

                  const [intPart, decimalPart] = raw.split(".");

                  // Add commas to integer part
                  const withCommas = intPart.replace(
                    /\B(?=(\d{3})+(?!\d))/g,
                    ",",
                  );

                  // Join back decimal part if it exists
                  const formatted =
                    decimalPart !== undefined
                      ? `${withCommas}.${decimalPart}`
                      : withCommas;

                  if (
                    availablePayables.find((item) => {
                      const price = item.totalPrice;
                      const precision17 = Number(
                        price.toPrecision(17),
                      ).toString();
                      const fixed17 = price.toFixed(17);
                      const fixed2 = price.toFixed(2);

                      return (
                        precision17.includes(raw) ||
                        fixed17.includes(raw) ||
                        fixed2.includes(raw)
                      );
                    })
                  ) {
                    setSearchTerm(formatted);
                  } else {
                    setSearchTerm(e.target.value);
                  }
                }}
              />
              <Button
                type="button"
                variant="outline-secondary"
                className="dropdown-toggle-split"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="fa-solid fa-sliders"></i>
              </Button>
              <ul className="dropdown-menu dropdown-menu-end">
                <li>
                  <button
                    className={`dropdown-item ${
                      filterColumn === "all" ? "active" : ""
                    }`}
                    onClick={() => setFilterColumn("all")}
                  >
                    All
                  </button>
                </li>
                {[
                  { value: "transaction_id", label: "Transaction ID" },
                  { value: "description", label: "Remarks" },
                  { value: "purchaseDate", label: "Purchase Date" },
                  { value: "due_date", label: "Due Date" },
                  { value: "totalPrice", label: "Amount" },
                  // { value: "discount_value", label: "Discount" },
                ].map(({ value, label }) => (
                  <li key={value}>
                    <button
                      className={`dropdown-item ${
                        filterColumn === value ? "active" : ""
                      }`}
                      onClick={() => setFilterColumn(value)}
                    >
                      {label}
                    </button>
                  </li>
                ))}
              </ul>
            </InputGroup>
          </Row>
          <DataTable
            columns={modalColumn}
            data={availablePayables}
            customStyles={customStyles}
            onRowClicked={(row) => handleIndividualCheckBoxChange(row.id)}
            className="dataTable"
          />
          <PaginationControls {...pagination} />
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setFilterColumn("all");
              setSearchTerm("");
              handleClose();
            }}
          >
            Close
          </Button>
          <Button variant="primary" onClick={submitModal}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default NEW_view_bulk_payable;
